export const GET_MEDS = 'GET_MEDS';
export const REQUEST_MED_REFILL = 'REQUEST_MED_REFILL';


// WEBPACK FOOTER //
// ./src/actions/medication/types.js